export default __webpack_public_path__ + "static/metaTrader4-69031a1a56017d380a78ee0f6c68198a.svg";